export default "__VITE_ASSET__Ua_ztbvm__"